import { render } from "./ChangePassHistoryTimeForm.vue?vue&type=template&id=e0ad1284"
import script from "./ChangePassHistoryTimeForm.vue?vue&type=script&lang=js"
export * from "./ChangePassHistoryTimeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__